import { combineReducers } from "redux";

import profileReducer from "../pages/Profile/redux/reducers";
import sessionReducer from "../common/auth/redux/reducer";
import generateReducer from "../pages/Generator/redux/reducers";
import s2rReducer from "../pages/S2R/redux/reducers";
import routesReducer from "../router/redux/reducers";
import pricingReducer from "../pages/Pricing/redux/reducers";

export default combineReducers({
  profile: profileReducer,
  session: sessionReducer,
  generator: generateReducer,
  s2r: s2rReducer,
  routes: routesReducer,
  pricing: pricingReducer,
});
